import { useEffect, useState } from 'react';

import { A11y, Autoplay, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import Button from '~/components/common/Button';
import { SlideLoader } from '~/components/common/SkeletonLoaders';

import { api_getBannersByBannerGroupName } from '~/backend/api_calls';

// Swiper Styles
import { useNavigate } from 'react-router';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import useWindowSize from '~/components/hooks/useWindowSize';

const HeroSlider = () => {
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const groupName = 'HeroSlider';
	const [banners, setBanners] = useState([]);
	const [shouldAutoplay, setShouldAutoplay] = useState(true);
	const { width } = useWindowSize();

	useEffect(() => {
		setLoading(true);
		api_getBannersByBannerGroupName(groupName)
			.then(json => {
				setBanners(json.items.sort((a, b) => a.si - b.si));
				const containsVideoBanner = json.items.find(x => x.video_url);
				setShouldAutoplay(!containsVideoBanner);
			})
			.catch(error => {
				console.log(error);
			})
			.finally(() => setLoading(false));
	}, []);

	if (loading) return <SlideLoader />;

	const swiperParams = {
		// Other Swiper configuration options...
		autoplay: shouldAutoplay
			? {
					delay: 4000, // Set your desired autoplay delay
					disableOnInteraction: true // Allow user interaction without stopping autoplay
				}
			: false
	};

	const renderBannerContent = banner => {
		// Video has priority
		if (banner.video_url) {
			let videoUrl = banner.video_url;
			if (width <= 650) {
				videoUrl = banner.video_url_mobile ?? banner.video_url;
			}
			return (
				<div className="home-video">
					<iframe
						src={
							'https://www.youtube.com/embed/' +
							videoUrl +
							`?rel=0&version=3&autoplay=1&modestbranding=1&autohide=1&controls=0&showinfo=0&playlist=${videoUrl}&loop=1&mute=1&disablekb=1&fs=0`
						}
						width={1920}
						height={1080}
						frameBorder="0"
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						allowFullScreen
						title={banner.tl}
					/>
				</div>
			);
		}

		// Otherwise render image
		return (
			<>
				<picture>
					<source media="(max-width:650px)" srcSet={banner.img2 ?? banner.img} />
					<img src={banner.img1} alt={banner.tl} />
				</picture>
				<div title={banner.tl} className="content-overlay">
					<div className="content">
						{banner.bd && <div dangerouslySetInnerHTML={{ __html: banner.bd }}></div>}
						{!banner.bd && <h2 className="title">{banner.tl}</h2>}
						<div className="button">
							<Button actionOnClick={() => navigate(banner.nu ?? '#')} outline={true} color={'light'}>
								ΔΕΣ ΠΕΡΙΣΣOΤΕΡΑ
							</Button>
						</div>
					</div>
				</div>
			</>
		);
	};

	return (
		<>
			<Swiper
				cssMode={true}
				modules={[Navigation, Pagination, A11y, Autoplay]}
				slidesPerView={1}
				loop={banners.length > 1}
				navigation={banners.length > 1}
				pagination={{ clickable: true }}
				scrollbar={{ draggable: true }}
				{...swiperParams}
				className="heroslider">
				{banners?.map(banner => (
					<SwiperSlide key={banner.id}>{renderBannerContent(banner)}</SwiperSlide>
				))}
			</Swiper>

			{/* <div className='boxnow-heroslider'>
					<h1>Προσφορές 2023</h1>
					<p>Η BLACK FRIDAY έρχεται στο SPORTISTAS.COM με απίστευετες προσφορές σε αθλητικά παπούτσια, ρούχα & αξεσουάρ στα κορυφαία brands ASICS, SPEEDO, TEVA, O'NEIL.</p>
					<h3>Stay Tuned</h3>
			</div> */}
		</>
	);
};

export default HeroSlider;
